<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card>
      <v-form lazy-validation @submit.prevent="submit" ref="form">
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-autocomplete
                  label="Lotação"
                  v-model="formData.lotacao"
                  :items="orgaos"
                  :loading="isloadingOrgao"
                  outlined
                  hide-no-data
                  hide-selected
                  item-text="nome"
                  item-value="id"
                  placeholder="Selecione uma lotação se desejar"
                  clearable
                  dense
                >
                  <template v-slot:selection="data">
                    {{ data.item.nome }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.nome }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-autocomplete
                  label="Situação"
                  v-model="formData.situacao"
                  :items="situacoes"
                  outlined
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="value"
                  placeholder="Selecione uma situação se desejar"
                  clearable
                  dense
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-autocomplete
                  label="Vínculos"
                  v-model="formData.vinculo"
                  :items="vinculos"
                  :loading="isloadingVinculo"
                  outlined
                  hide-no-data
                  hide-selected
                  item-text="nome"
                  item-value="id"
                  placeholder="Selecione um vínculo se desejar"
                  clearable
                  dense
                >
                  <template v-slot:selection="data">
                    {{ data.item.nome }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.nome }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" md="3" cols="12">
                <v-text-field
                  class="pa-0"
                  dense
                  label="Placa"
                  outlined
                  v-model="formData.placa"
                ></v-text-field>
              </v-col>
              <v-col cols="9" class="py-0">
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-autocomplete
                      label="Marca"
                      v-model="formData.marca"
                      :items="marcas"
                      :loading="isloadingMarca"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      placeholder="Selecione uma marca"
                      clearable
                      dense
                      @change="loadModelos"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-autocomplete
                      label="Modelo"
                      v-model="formData.modelo"
                      :items="modelos"
                      :loading="isloadingModelo"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      placeholder="Selecione um modelo"
                      clearable
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-autocomplete
                  label="Motoristas"
                  v-model="formData.motorista"
                  :items="motoristas"
                  :loading="isloadingMotoristas"
                  outlined
                  hide-no-data
                  hide-selected
                  item-text="pessoa.nome"
                  item-value="id"
                  placeholder="Selecione um motorista"
                  clearable
                  dense
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" md="4" cols="12">
                <v-radio-group v-model="formData.importado" row>
                  <template v-slot:label>
                    <div>Importado?</div>
                  </template>
                  <v-radio label="Sim" value="S"></v-radio>
                  <v-radio label="Não" value="N"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="py-0" md="4" cols="12">
                <v-radio-group v-model="formData.is_motorista" row>
                  <template v-slot:label>
                    <div>Apresentar Motorista?</div>
                  </template>
                  <v-radio label="Sim" value="S"></v-radio>
                  <v-radio label="Não" value="N"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="py-0" md="4" cols="12">
                <v-radio-group v-model="formData.is_rota" row>
                  <template v-slot:label>
                    <div>Apresentar Rota?</div>
                  </template>
                  <v-radio label="Sim" value="S"></v-radio>
                  <v-radio label="Não" value="N"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn depressed :loading="isloadingSubmit" color="green" dark type="submit">
            <v-icon small left>mdi-send</v-icon>
            Buscar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <PDF />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PDF from '@/views/public/modal/Pdf.vue';
import relatoriosHttp from '@/services/http/resources/configuracao/relatoriosHttp';
import orgaoHttp from '@/services/http/resources/configuracao/orgaoHttp';
import marcaHttp from '@/services/http/resources/frota/marcaHttp';
import modeloHttp from '@/services/http/resources/frota/modeloHttp';
import motoristaHttp from '@/services/http/resources/frota/motoristaHttp';
import vinculoHttp from '@/services/http/resources/frota/vinculoHttp';
import toastMessage from '@/services/util/alertService';

export default {
  name: 'RelatorioVeiculos',
  components: {
    PDF,
  },
  metaInfo: {
    title: 'Relatórios Veículo',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Relatórios Veículo',
    marcas: [],
    modelos: [],
    motoristas: [],
    orgaos: [],
    vinculos: [],
    situacoes: [
      { value: 'A', text: 'Ativo' },
      { value: 'I', text: 'Inativo' },
    ],
    formData: {
      lotacao: '',
      situacao: '',
      vinculo: '',
      marca: '',
      modelo: '',
      placa: '',
      motorista: '',
      importado: 'N',
      is_rota: 'N',
      is_motorista: 'N',
    },
    isloadingSubmit: false,
    isloadingOrgao: false,
    isloadingVinculo: false,
    isloadingMarca: false,
    isloadingModelo: false,
    isloadingMotoristas: false,
  }),
  mounted() {
    this.loadOrgaos();
    this.loadVinculos();
    this.loadMarcas();
    this.loadMotoristas();
  },
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
    submit() {
      this.isloadingSubmit = true;
      relatoriosHttp
        .veiculos(this.formData)
        .then(({ data }) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          this.toggleModalPdf(fileURL);
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar documento.'))
        .finally(() => {
          this.isloadingSubmit = false;
        });
    },
    loadMotoristas() {
      this.isloadingMotoristas = true;
      motoristaHttp
        .list()
        .then(({ data: { data } }) => {
          this.motoristas = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Motoristas'))
        .finally(() => {
          this.isloadingMotoristas = false;
        });
    },
    loadOrgaos() {
      this.isloadingOrgao = true;
      orgaoHttp
        .list()
        .then(({ data: { data } }) => {
          this.orgaos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar orgãos'))
        .finally(() => {
          this.isloadingOrgao = false;
        });
    },
    loadMarcas() {
      this.isloadingMarca = true;
      marcaHttp
        .list()
        .then(({ data: { data } }) => {
          this.marcas = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar marcas'))
        .finally(() => {
          this.isloadingMarca = false;
        });
    },
    loadModelos() {
      if (this.formData.marca) {
        this.isloadingModelo = true;
        modeloHttp
          .list(this.formData.marca)
          .then(({ data: { data } }) => {
            this.modelos = data;
          })
          .catch(() => toastMessage.errorLoading('Erro ao carregar modelos'))
          .finally(() => {
            this.isloadingModelo = false;
          });
      } else {
        this.modelos = [];
      }
    },
    loadVinculos() {
      this.isloadingVinculo = true;
      vinculoHttp
        .list()
        .then(({ data: { data } }) => {
          this.vinculos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar vínculos'))
        .finally(() => {
          this.isloadingVinculo = false;
        });
    },
  },
};
</script>

<style></style>
